export default "__VITE_ASSET__DCr_MixK__"